/***
*
*   BILLING / PLAN
*   Update the billing plan
*
**********/

import React, { useContext, Fragment } from 'react';
import { AuthContext, ViewContext, Card, Form, Message, usePlans, Button } from 'components/lib';

export function BillingPlan(props){

  const plans = usePlans();
  const context = useContext(AuthContext);
  const viewContext = useContext(ViewContext);
  function closeAccount(){
    if(context.permission.owner){
    viewContext.modal.show({

      title: 'Close Your Account',
      form: {},
      buttonText: 'Close Account',
      url:  '/api/account',
      method: 'DELETE',
      destructive: true,
      text: 'Are you sure you want to delete your account? ' +
      'You will lose all of your data and this can not be undone.',

    }, () => {

      // destory user
      Event('closed_account');
      localStorage.clear();
      History.push('/signup');

    });
  }
  }

  

  return (
    <Card loading={ plans.loading || props.subscription.loading } mediumWidth className={ props.className }>

      { props.subscription?.data?.object && 
        <Message 
          type='info'
          title='Subscription Details'
          text={ `You are already subscribed to the ${plans.data.list[0].label} plan. Thank you! Your billing cycle is: ${props.subscription.data.object.current_period_start} to ${props.subscription.data.object.current_period_end}` }
        />
      }

      { plans?.data?.list?.length > 1  &&
          
        <Form
          data={{
            plan: {
              label: 'Your subscription plan',
              type: 'select',
              required: true,
              default: plans?.data?.active,
              options: plans?.data?.list
            }
          }}
          url='/api/billing/plan'
          method='PATCH'
          buttonText='Select Plan'
          callback={(res) => {
            context.update({ plan: res.data.data.plan });
          }}
        />
      }

      {context.permission.owner &&
        <Fragment>
          <br/>
          <br/> {/* Add extra spacing */}
          <Button
            textOnly
            action={ closeAccount }
            text='Close Your Account'
          />
        </Fragment>
      }
    </Card>
  )
}